import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ScaleIconNavigationCollapseDown,
  ScaleIconUserFileUser,
  ScaleMenuFlyout,
  ScaleMenuFlyoutDivider,
  ScaleMenuFlyoutItem,
  ScaleMenuFlyoutList,
} from '@cloudorder/ui';

import styles from './UserProfileMenu.module.css';

type UserProfileMenuProps = {
  name: string;
  email: string;
  onLogout: () => void;
};

export function UserProfileMenu({ name, email, onLogout }: UserProfileMenuProps): ReactElement {
  const { t } = useTranslation('app');

  return (
    <ScaleMenuFlyout className={styles.menu} direction="bottom-left">
      <button
        type="button"
        className={styles.trigger}
        slot="trigger"
        aria-label={t('profile.openMenu', { name })}
      >
        <span className={styles.avatar} aria-hidden="true">
          <ScaleIconUserFileUser size={20} decorative />
          <span className={styles.status} />
        </span>
        <span className={styles.name} title={name}>
          {name}
        </span>
        <ScaleIconNavigationCollapseDown
          className={styles.chevron}
          size={12}
          decorative
          aria-hidden="true"
        />
      </button>

      <ScaleMenuFlyoutList className={styles.flyout} aria-label={t('profile.menuLabel')}>
        <div className={styles.summary}>
          <strong>{name}</strong>
          {email ? <span>{email}</span> : null}
        </div>
        <ScaleMenuFlyoutDivider />
        <ScaleMenuFlyoutItem onScaleSelect={onLogout}>{t('profile.signOut')}</ScaleMenuFlyoutItem>
      </ScaleMenuFlyoutList>
    </ScaleMenuFlyout>
  );
}
